<template>
  <b-row>
    <b-col >
      <img v-if="isLoading" :src="loadingSpinner" alt="loading"/>
      
      <template v-else>
        <b-form-row class="photo">
            <img class="photo" :src="therapist.photoUrl || noPhoto" alt="Upload de foto"/>
        </b-form-row>

        <b-form-row class="photo">
          <FormulateInput
            type="image"
            name="photoBuffer"
            label="Selecione uma imagem para upload."
            help="Formatos aceitos: png, jpg ou gif."
            validation="mime:image/jpeg,image/png,image/gif"
            upload-behavior="delayed"
            v-model="photoBuffer"
            :validation-messages="{ mime: 'Formato de imagem inválido' }"
            @validation="({hasErrors}) => isImageInvalid = hasErrors"
          />
        </b-form-row>

        <FormulateForm v-model="therapist" @submit="handleSubmit">
          <b-form-row>
            <b-col class="my-4">
              <FormulateInput
                type="text"
                name="name"
                label="Nome"
                validation="required"
                error-behavior="blur"
              />
            </b-col>
            <b-col class="my-4">
              <FormulateInput
                name="emails"
                label="Emails de contato"
                placeholder="Email"
              />
            </b-col>
          </b-form-row>
          
          <b-form-row>
            <b-col md="11" class="my-4">
              <FormulateInput
                type="text"
                name="address"
                label="Endereço"
              />
            </b-col>
          </b-form-row>
          <b-form-row style="margin-top: 15px; margin-bottom: 15px;">
            <b-col md="7">
              <label><strong>Estado</strong></label>
              <b-form-select class="form-select" :options="stateOptions" @change="listCities" v-model="therapist.brazilianState">
                <template #first>
                  <b-form-select-option :value="{}" disabled>Selecione o estado</b-form-select-option>
                  <b-form-select-option :value="{}"></b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </b-form-row>
          <b-form-row>
             <b-col md="7">
               <label><strong>Cidade</strong></label>
              <b-form-select class="form-select"
                :disabled="!(cityOptions && cityOptions.length)" 
                :options="cityOptions" 
                v-model="therapist.brazilianCity"
              >
                <template #first>
                  <b-form-select-option :value="{}" disabled>Selecione a cidade</b-form-select-option>
                  <b-form-select-option :value="{}"></b-form-select-option>
                </template>
              </b-form-select>
             </b-col>
          </b-form-row>

          <b-form-row style="margin-top: 20px;">
            <b-col>
              <FormulateInput
                type="text"
                name="phoneNumber"
                label="Telefone(s) de contato"
                placeholder="Ex: + 55 31 98975346, (31) 99987-4563"
                help="Texto livre. Pode conter vários números de telefone"
              />
            </b-col>
            <b-col class="my-4">
              <FormulateInput
                type="text"
                name="whatsappNumber"
                label="Número de whatsapp"
                validation="phoneNumber"
                placeholder="Ex: 553198975346"
                help="Número completo contendo o código do país e do estado como prefixo. Ex: 553198975346."
                :validation-rules="{
                  phoneNumber: ({value}) => !/[^\d]/.test(value)
                }"
                :validation-messages="{
                  phoneNumber: 'Número de telefone só pode conter dígitos numéricos, ou ponto (.). Ex: 553198975346'
                }"
              />
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col class="my-4">
              <FormulateInput
                type="text"
                name="facebookProfileName"
                label="Perfil do Facebook"
                placeholder="Ex: zuck"
                validation="facebookProfile"
                :validation-rules="{
                  facebookProfile: ({value}) => !/[^\d\w\.\-]/.test(value)
                }"
                :validation-messages="{
                  facebookProfile: 'Perfil só pode conter letras, números, ponto (.), hífen (-) ou underscore (_). Ex: maha_lilah'
                }"
              />
            </b-col>
            <b-col class="my-4">
                <FormulateInput
                type="text"
                name="instagramProfileName"
                label="Perfil do Instagram"
                placeholder="Ex: maha_lilah (sem @)"
                validation="instagramProfile"
                :validation-rules="{
                  instagramProfile: ({value}) => !/[^\d\w\.\_]/.test(value)
                }"
                :validation-messages="{
                  instagramProfile: 'Perfil só pode conter letras, números, underscore (_) ou ponto (.). Ex: maha_lilah'
                }"
              />
            </b-col>
          </b-form-row>

          <FormulateInput
            type="text"
            name="siteUrl"
            label="Endereço site próprio"
          />

          <FormulateInput 
              rows="10"
              element-class="description"
              type="textarea"
              name="selfDescription"
              label="Descrição"
              validation="max:1000,length"
              validation-name="description"
              error-behavior="live"
              :help="`Máximo de 1000 caracteres.`"
              :validation-messages="{
                max: 'Descrição deve ter no máximo 1000 caracteres.'  
              }"
          />
          <FormulateInput v-if="!id" type="submit" label="Criar" />
          <FormulateInput v-else type="submit" label="Atualizar" />
        </FormulateForm>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import * as therapistsApiClient from '../js/therapistsApiClient'
import loadingSpinner from '../assets/images/Spinner-0.8s-200px.gif';
import noPhoto from '../assets/images/no-photo.png'
import geoApiClient from '../js/geoApiClient';
import Vue from 'vue'
import * as usersApiClient from "@/js/usersApiClient";

export default {
    name: 'TherapistForm',
    props: {
      therapistId: Number,
    },
    data() {
        return {
          id: this.$route.params.id || this.therapistId,
          isLoading: false,
          therapist: {},
          loadingSpinner,
          noPhoto,
          photoBuffer: null,
          isImageInvalid: false,
          stateOptions: null,
          cityOptions: null,
        }
    },
    watch: {
      therapistId: async function(newVal) {
        this.id = newVal;
        await this.getTherapist();
      },
    },
    async mounted() {
      await this.getTherapist();
      await this.getStates();
    },
    methods: {
      async listCities() {
        this.cityOptions = [];
        this.therapist.brazilianCity = '';

        if (this.therapist.brazilianState) {
          this.cityOptions = await geoApiClient.listBrazilianCitiesNamesAsync(this.therapist.brazilianState);
        }
      },
      async getStates(){
        this.stateOptions = await geoApiClient.listBrazilianStatesNamesAsync(false);
      },
      async getTherapist() {
        if (this.id) {
          this.isLoading = true;
          
          const getTherapistResponse = await therapistsApiClient.getTherapist(this.id);
          
          if (getTherapistResponse.success) {
            if (this.therapist.brazilianState) {
              this.cityOptions = await geoApiClient.listBrazilianCitiesNamesAsync(this.therapist.brazilianState);
            }

            this.therapist = getTherapistResponse.data;
          }
          else {
            Vue.$toast.error(`Erro ao buscar terapeuta.\nMotivo: ${getTherapistResponse.errors[0]?.message}`)
          }
          
          this.isLoading = false;
        }
      },
      async handleSubmit() {

        if (this.isImageInvalid) {
          return;
        }

        this.isLoading = true;

        const the = this.therapist;

        if (this.photoBuffer) {
          const paths = await this.photoBuffer.upload();
          the.photoUrl = paths[0].url;
        } 
       
        if (this.id) {
          await therapistsApiClient.updateTherapist(the);
        }
        else {
          await usersApiClient.createUserAsync(the);
        }

        await this.getTherapist();

        this.photoBuffer = null;

        this.isLoading = false;
      }
    },
}
</script>

<style scoped>

.photo {
  height: 120px;
  width: auto;
  justify-content: center;
  align-content: center;
  margin: 30px;
}

.description {
  width: 100%;
  height: 240px;
}

textarea {
  width: 300px;
  height: 150px;
}

</style>
